import { Component, HostListener, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { BehaviourSettingServices } from '../../../../../services/BehaviourSetting.services'
import { SharedServices } from '../../../../../services/shared.services'

@Component({
    selector: 'app-modal-behavior-form-setting',
    templateUrl: './modal-behavior-form-setting.component.html',
    styleUrls: [
        './modal-behavior-form-setting.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/main-view.component.css',
    ],
})
export class ModalBehaviorFormSettingComponent implements OnInit {

    form_behaviour: any = 'hidden'
    title: any = 'aligner'
    tabArray: any
    arrShow: any[] = []
    levelMultiIndex: any = 1
    jsonTimeline: any = {}

    jsonAllFormSetting: any = {}
    firstJsonAllFormSetting: any = {}
    level: any = 1

    allArr: any[] = []

    firstArray: any[] = []
    view = 'form-setting'

    lengthUndoArray: any


    arrayRespone: any[] = []
    arrConvert: any[] = []

    changeEmittedJsonBehaviorSetting : any
    changeEmittedArrFormSetting :any
    changeEmittedArrTimeline :any
    changeEmittedStatusFormSetting :any
    changeEmittedFormSetting :any

    constructor(private behaviourSettingServices: BehaviourSettingServices,
                private formBuilder: FormBuilder,
                private _sharedService: SharedServices) {
    }

    ngOnInit() {
        this.changeEmittedJsonBehaviorSetting = this.behaviourSettingServices.changeEmittedJsonBehaviorSetting$.subscribe(json => {
            if (json != null && json != undefined) {
                this.jsonAllFormSetting = json['json']
                this.firstJsonAllFormSetting = $.extend(true, [], this.jsonAllFormSetting)
            }
        })
        this.form_behaviour = 'hidden'
        this.getStatusFormSetting()
        this.getArrAll()
        this.getTimeline()
        const emitState: any = {}
        emitState['state'] = 'new'
        this.behaviourSettingServices.emitChangeState(emitState)
    }



    ngOnDestroy(){
        this.changeEmittedJsonBehaviorSetting.unsubscribe()
        this.changeEmittedArrFormSetting.unsubscribe()
        this.changeEmittedArrTimeline.unsubscribe()
        this.changeEmittedStatusFormSetting.unsubscribe()
        this.changeEmittedFormSetting.unsubscribe()

    }

    recursiveData(data, level, parent) {
        if (data && data.length > 0) {
            data.forEach((el, i) => {
                el['level'] = level
                if (el['schema'] && el['schema']['items']) {
                    const arrayProperty: any[] = el['schema']['items']['properties']
                    this.recursiveData(arrayProperty, level + 1, el['propertyName'])
                }
                const find = this.arrConvert.find(item => {
                    return item['propertyName'] == el['propertyName']
                })
                if (!find) {
                    el['parent'] = parent
                    this.arrConvert.push(el)
                }
            })
        }
    }

    convertArray(jsonRes) {
        const arrayRes: any[] = jsonRes['properties']
        const level = 0
        this.arrConvert = []
        if (arrayRes) {
            arrayRes.forEach((el, i) => {
                el['level'] = level
                if (el['schema'] && el['schema']['items']) {
                    const arrayProperty: any[] = el['schema']['items']['properties']
                    this.recursiveData(arrayProperty, level + 1, el['propertyName'])
                }
                const find = this.arrConvert.find(item => {
                    return item['propertyName'] == el['propertyName']
                })
                if (!find) {
                    this.arrConvert.push(el)
                }
            })
        }
        return this.arrConvert
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        const showView: any = this.behaviourSettingServices.returnView()
        if (showView != '' && showView == this.view) {
            if (keyPressed === 27) {
                if (event) {
                    event.preventDefault()
                }
                this.closeModal()
            } else if (keyPressed == 13) {
                event.preventDefault()
            }
        }
    }

    getArrAll() {
        this.changeEmittedArrFormSetting = this.behaviourSettingServices.changeEmittedArrFormSetting$.subscribe(arr => {
            if (arr != null && arr != undefined && arr['arrFormSetting'] != undefined && arr['option'] != 'timeline') {
                this.allArr = arr['arrFormSetting']
                if (this.allArr.length > 0) {
                    this.arrShow = this.allArr.filter(el => {
                        return el['level'] == 0
                    })
                } else {
                    this.arrShow = []
                }
                const emitProperties: any = {}
                emitProperties['properties'] = arr['arrFormSetting']
                this.jsonAllFormSetting[this.tabArray] = emitProperties 
            }
        })
    }

    getTimeline() {
        this.changeEmittedArrTimeline =this.behaviourSettingServices.changeEmittedArrTimeline$.subscribe(timeline => {
            if (timeline != null && timeline != undefined && timeline['timeline'] != undefined) {
                this.arrShow = timeline['timeline']
                this.jsonAllFormSetting[this.tabArray] = this.arrShow 
            }
        })
    }

    moveUp(index: any) {
        //
        const nextIndex: any = index - 1
        if (nextIndex >= 0) {
            const jsonIndex = this.arrShow.find((el, i) => {
                return i == index
            })
            const jsonNextIndex = this.arrShow.find((el, i) => {
                return i == nextIndex
            })
            this.arrShow[index] = jsonNextIndex
            this.arrShow[nextIndex] = jsonIndex

            if (this.tabArray != 'timelineForms') {

                const findIndexItemMove = this.allArr.findIndex(el => {
                    return el['propertyName'] == jsonIndex['propertyName']
                })
                const findIndexNextItemMove = this.allArr.findIndex(el => {
                    return el['propertyName'] == jsonNextIndex['propertyName']
                })
                this.allArr[findIndexItemMove] = jsonNextIndex
                this.allArr[findIndexNextItemMove] = jsonIndex
            }
        }
    }

    moveDown(index: any) {
        //
        const nextIndex: any = index + 1
        if (nextIndex < this.arrShow.length) {
            const jsonIndex = this.arrShow.find((el, i) => {
                return i == index
            })
            const jsonNextIndex = this.arrShow.find((el, i) => {
                return i == nextIndex
            })
            this.arrShow[index] = jsonNextIndex
            this.arrShow[nextIndex] = jsonIndex

            if (this.tabArray != 'timelineForms') {

                const findIndexItemMove = this.allArr.findIndex(el => {
                    return el['propertyName'] == jsonIndex['propertyName']
                })
                const findIndexNextItemMove = this.allArr.findIndex(el => {
                    return el['propertyName'] == jsonNextIndex['propertyName']
                })
                this.allArr[findIndexItemMove] = jsonNextIndex
                this.allArr[findIndexNextItemMove] = jsonIndex
            }
        }
    }

    removeAll() {
        if (this.tabArray != 'timelineForms') {
            this.jsonAllFormSetting[this.tabArray] = []
            this.allArr = this.jsonAllFormSetting[this.tabArray]
            this.jsonAllFormSetting['updateTime'] = new Date().getTime().toString()
            if (this.allArr.length > 0) {
                this.arrShow = this.allArr.filter(el => {
                    return el['level'] == 0
                })
            } else {
                this.arrShow = []
            }
            const emitArr: any = {}
            emitArr['arrFormSetting'] = this.allArr
            emitArr['option'] = this.tabArray
            this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)

            const emitJsonAll: any = {}
            emitJsonAll['json'] = this.jsonAllFormSetting
            this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)

            this.form_behaviour = 'hidden'
            const emitChangeOptionShow: any = {}
            emitChangeOptionShow['statusFormSetting'] = 'hidden'
            this.behaviourSettingServices.emitChangeStatusFormSetting(emitChangeOptionShow)

            const emitDataSave = {}
            emitDataSave['data'] = []
            emitDataSave['tabName'] = this.tabArray
            this.behaviourSettingServices.emitChangeSaveSetting(emitDataSave)

            this._sharedService.emitChange('activeAlertSaveForm')
        } else {
            this.arrShow = []
            this.jsonAllFormSetting[this.tabArray] = this.arrShow
            const emitJsonAll: any = {}
            emitJsonAll['json'] = this.jsonAllFormSetting
            this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)

            const emitDataSave = {}
            emitDataSave['data'] = []
            emitDataSave['tabName'] = this.tabArray
            this.behaviourSettingServices.emitChangeSaveSetting(emitDataSave)
            this._sharedService.emitChange('activeAlertSaveForm')

            this.form_behaviour = 'hidden'
            const emitChangeOptionShow: any = {}
            emitChangeOptionShow['statusFormSetting'] = 'hidden'
            this.behaviourSettingServices.emitChangeStatusFormSetting(emitChangeOptionShow)
        }
    }

    resetArray(arrayUndo: any[] = []) {

        const item = arrayUndo[0]
        if (item) {
            if (item['level'] != 0) {
                if (typeof item.level != 'undefined') {
                    delete item.level
                }
                if (typeof item.parent != 'undefined') {
                    delete item.parent
                }
                const findIndex = arrayUndo.findIndex(function(el, i) {
                    return el['propertyName'] == item['propertyName']
                })
                arrayUndo.splice(0, 1)
                const findItem = arrayUndo[findIndex]
                if (findItem) {
                    if (findItem && findItem['schema'] && findItem['schema']['items'] && findItem['schema']['items']['properties']) {
                        const arrProperties: any[] = findItem['schema']['items']['properties']
                        if (arrProperties && arrProperties.length > 0) {
                            const replaceElementIndex = arrProperties.findIndex(function(el, i) {
                                return el['propertyName'] == item['propertyName']
                            })
                            if (replaceElementIndex != -1) {
                                arrProperties[replaceElementIndex] = item
                                findItem['schema']['items']['properties'] = arrProperties
                            }
                        } else {
                            delete findItem.schema.items['properties']
                        }
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['options']) {
                        const tmpOptions: any[] = findItem['schema']['options']
                        if (tmpOptions.length == 0) {
                            delete findItem.schema['options']
                        } else if (tmpOptions.length == 1) {
                            const itemOption = tmpOptions[0]
                            if (itemOption['title'] == '') {
                                delete findItem.schema['options']
                            }
                        }
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['uiOptions'] && findItem['schema']['uiOptions']['behavior'] == '') {
                        delete findItem.schema['uiOptions']
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['uiConditionType'] == null) {
                        delete findItem.schema['uiConditionType']
                    }
                    if (findItem && findItem['schema'] && findItem['schema']['uiType'] == null) {
                        delete findItem.schema['uiType']
                    }
                    arrayUndo[findIndex] = findItem
                }
                this.resetArray(arrayUndo)
            }
        } else {
            arrayUndo.splice(0, 1)
            this.resetArray(arrayUndo)
        }
        return arrayUndo
    }

    undoArrayAllSetting() {
        let undoArray: any[] = []
        const tmpArrayLevelZero = this.allArr.filter(function(el, i) {
            return el['level'] == 0
        })
        this.lengthUndoArray = tmpArrayLevelZero.length
        if (this.lengthUndoArray > 0) {
            this.allArr.sort(function(a, b) {
                return b['level'] - a['level']
            })
            const resetArr = this.resetArray(this.allArr)
            undoArray = jQuery.extend(true, [], resetArr)
            undoArray.forEach(function(el, i) {
                if (el) {
                    if (typeof el.level != 'undefined') {
                        delete el.level
                    }
                    if (typeof el.parent != 'undefined') {
                        delete el.parent
                    }
                    if (el['schema'] && el['schema']['items'] && el['schema']['items']['properties']) {
                        const arrProperties: any[] = el['schema']['items']['properties']
                        if (arrProperties && arrProperties.length == 0) {
                            delete el.schema.items['properties']
                        }
                    }
                    if (el['schema'] && el['schema']['options']) {
                        const tmpOptions: any[] = el['schema']['options']
                        if (tmpOptions.length == 0) {
                            delete el.schema['options']
                        } else if (tmpOptions.length == 1) {
                            const itemOption = tmpOptions[0]
                            if (itemOption['title'] == '') {
                                delete el.schema['options']
                            }
                        }
                    }
                    if (el['schema'] && el['schema']['uiConditionType'] == null) {
                        delete el.schema['uiConditionType']
                    }
                    if (el['schema'] && el['schema']['uiType'] == null) {
                        delete el.schema['uiType']
                    }
                    if (el['schema'] && el['schema']['uiOptions'] && el['schema'] && el['schema']['uiOptions']['behavior'] == '') {
                        delete el.schema['uiOptions']
                    }
                    undoArray[i] = el
                }
            })
            const jsonArr = {}
            jsonArr['properties'] = undoArray


            const jsonDataSave = this.behaviourSettingServices.returnArr()
            // if(this.tabArray == jsonDataSave['option']) {
            //     console.log('option')
            //     const arrFormTab = {}
            //     arrFormTab['properties'] = jsonDataSave['arrFormSetting']
            //     console.log(arrFormTab)
            //     this.jsonAllFormSetting[this.tabArray] = arrFormTab     
            // }

            this.jsonAllFormSetting[this.tabArray] = jsonArr

            // const result: any = undoArray.filter(function(el) {
            //     return (el['title'] && el['title'] != '');
            // });

            const emitDataSave = {}
            emitDataSave['data'] = undoArray
            emitDataSave['tabName'] = this.tabArray
            this.behaviourSettingServices.emitChangeSaveSetting(emitDataSave)
        } else {
            undoArray = []
            this.allArr = []
            this.jsonAllFormSetting[this.tabArray] = this.allArr
            const emitJsonAll: any = {}
            emitJsonAll['json'] = this.jsonAllFormSetting
            this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)

            const emitDataSave = {}
            emitDataSave['data'] = []
            emitDataSave['tabName'] = this.tabArray
            this.behaviourSettingServices.emitChangeSaveSetting(emitDataSave)
        }
        return undoArray
    }

    onSave() {
        if (this.tabArray != 'timelineForms') {            
            this.undoArrayAllSetting()
            const emitJsonAll: any = {}
            emitJsonAll['json'] = this.jsonAllFormSetting 
            this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)
            this.form_behaviour = 'hidden'
            const emitChangeOptionShow: any = {}
            emitChangeOptionShow['statusFormSetting'] = 'hidden'
            this.behaviourSettingServices.emitChangeStatusFormSetting(emitChangeOptionShow)
            this._sharedService.emitChange('activeAlertSaveForm')
        } else {
            const jsonTimeline = this.behaviourSettingServices.returnArrTimeline()
            const arrTimeline = jsonTimeline['timeline']
            this.jsonAllFormSetting[this.tabArray] = arrTimeline
            this.jsonAllFormSetting['updateTime'] = new Date().getTime().toString()

            const emitJsonAll: any = {}
            emitJsonAll['json'] = this.jsonAllFormSetting
            this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)

            this.form_behaviour = 'hidden'
            const emitChangeOptionShow: any = {}
            emitChangeOptionShow['statusFormSetting'] = 'hidden'
            this.behaviourSettingServices.emitChangeStatusFormSetting(emitChangeOptionShow)


            const emitDataSave = {}
            emitDataSave['data'] = arrTimeline
            emitDataSave['tabName'] = this.tabArray
            this.behaviourSettingServices.emitChangeSaveSetting(emitDataSave)
            this._sharedService.emitChange('activeAlertSaveForm')
        }
    }

    // this.allArr[this.tabArray] = this.arrShow;
    // const emitArr: any = {};
    // emitArr['arrFormSetting'] = this.allArr;
    // this.behaviourSettingServices.emitChangeArrFormSetting(emitArr);


    getStatusFormSetting() {
       this.changeEmittedStatusFormSetting = this.behaviourSettingServices.changeEmittedStatusFormSetting$.subscribe(option => {
            if (option != null && option['statusFormSetting'] != undefined) {
                this.form_behaviour = option['statusFormSetting']
            }
        }, error1 => {
        })
        this.getArrShow()
    }

    getArrShow() {
        this.changeEmittedFormSetting =this.behaviourSettingServices.changeEmittedFormSetting$.subscribe(option => {
            if (option != null && option['formSetting'] != undefined) {
                this.arrShow = []
                this.tabArray = option['formSetting']
                switch (this.tabArray) {
                    case 'clientAlignerForm':
                        this.title = 'Aligner Form'
                        break
                    case 'clientProfileFormHeader':
                        this.title = 'Client Form Header'
                        break
                    case 'clientProfileFormFooter':
                        this.title = 'Client Form Footer'
                        break
                    case 'timelineForms':
                        this.title = 'Forms in Timeline'
                        break
                    default:
                        this.title = 'Aligner Form'
                        break
                }
                if (this.tabArray != 'timelineForms') {
                    this.firstArray = []
                    this.allArr = []
                    const respArr = this.jsonAllFormSetting[this.tabArray] ? this.jsonAllFormSetting[this.tabArray] : []
                    const tmpArrConvert = this.convertArray(respArr)
                    this.allArr = jQuery.extend(true, [], tmpArrConvert)
                    if (this.allArr && this.allArr.length > 0) {
                        this.firstArray = $.extend(true, [], this.allArr)
                    }
                    if (this.allArr.length > 0) {
                        this.arrShow = this.allArr.filter(el => {
                            return el['level'] == 0
                        })
                    } else {
                        this.arrShow = []
                    }
                    const emitArr: any = {}
                    emitArr['arrFormSetting'] = this.allArr
                    emitArr['option'] = this.tabArray
                    this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
                } else {
                    this.arrShow = this.jsonAllFormSetting[this.tabArray] ? this.jsonAllFormSetting[this.tabArray] : []
                    // this.firstArray = [];
                    // if (this.arrShow && this.arrShow.length > 0) {
                    //     this.allArr.forEach(el => {
                    //         this.firstArray.push(el);
                    //     });
                    // }
                    const emitArr: any = {}
                    emitArr['timeline'] = this.arrShow
                    emitArr['option'] = this.tabArray
                    this.behaviourSettingServices.emitChangeArrTimeline(emitArr)
                }
            }
        })
    }

    remove(index) {
        if (this.tabArray != 'timelineForms') {
            const json: any = this.arrShow[index]
            this.arrShow.splice(index, 1)
            const ind: any = this.allArr.findIndex((el, i) => {
                return el['propertyName'] == json['propertyName']
            })
            if (ind != -1) {
                this.allArr.splice(ind, 1)
            }
            const emitArr: any = {}
            emitArr['arrFormSetting'] = this.allArr
            emitArr['option'] = this.tabArray
            this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
        } else {
            this.arrShow.splice(index, 1)
            const emitArr: any = {}
            emitArr['timeline'] = this.arrShow
            emitArr['option'] = this.tabArray
            this.behaviourSettingServices.emitChangeArrTimeline(emitArr)
        }
    }

    addItem() {
        if (this.tabArray != 'timelineForms') {
            const newItem: any = {}
            newItem['conditionTarget'] = ''
            newItem['isCondition'] = false
            newItem['isListField'] = false
            newItem['propertyName'] = new Date().getTime().toString()
            // newItem['multipleItem'] = [];
            newItem['schema'] = {}
            newItem['title'] = ''
            newItem['type'] = 'normal'
            newItem['level'] = 0
            this.arrShow.push(newItem)
            this.allArr.push(newItem)
            const emitArr: any = {}
            emitArr['arrFormSetting'] = this.allArr
            emitArr['option'] = this.tabArray
            this.behaviourSettingServices.emitChangeArrFormSetting(emitArr)
        } else {
            const newItem: any = {}
            newItem['_id'] = new Date().getTime().toString()
            newItem['tags'] = []
            newItem['deleted'] = false
            newItem['title'] = ''
            newItem['room'] = ''
            newItem['schema'] = undefined
            this.arrShow.push(newItem)
            const emitArr: any = {}
            emitArr['timeline'] = this.arrShow
            emitArr['option'] = this.tabArray
            this.behaviourSettingServices.emitChangeArrTimeline(emitArr)
        }
    }

    openModal(propertyName) {
        if (this.tabArray != 'timelineForms') {
            const emitState: any = {}
            emitState['state'] = 'new'
            this.behaviourSettingServices.emitChangeState(emitState)
            const emitDetailForm: any = {}
            this.levelMultiIndex = propertyName
            const status: any = 'statusDetailForm-' + this.levelMultiIndex
            emitDetailForm[status] = 'active'
            this.behaviourSettingServices.emitChangeStatusDetailFormSetting(emitDetailForm)
            const countLevel: any = {}
            countLevel['identify'] = this.levelMultiIndex
            this.behaviourSettingServices.emitChangeCountLevel(countLevel)

            const emitLevel: any = {}
            emitLevel['level'] = this.level
            this.behaviourSettingServices.emitChangeLevel(emitLevel)
            const emitOldId: any = {}
            emitOldId['oldId'] = propertyName
            this.behaviourSettingServices.emitChangeOldId(emitOldId)
            const emitView: any = {}
            emitView['view'] = 'detail-form-setting'
            this.behaviourSettingServices.emitChangeView(emitView)
        } else {
            const emit: any = {}
            emit['status'] = 'active'
            this.behaviourSettingServices.emitChangeIsActiveModalFormInTimeline(emit)
            const emitId: any = {}
            emitId['id'] = propertyName
            this.behaviourSettingServices.emitChangeIdentifyTimeline(emitId)
            const emitView: any = {}
            emitView['view'] = 'form-in-timeline'
            this.behaviourSettingServices.emitChangeView(emitView)
        }
    }

    closeModal() {
        this.allArr = []
        const json = {}
        json['properties'] = this.firstArray
        this.jsonAllFormSetting[this.tabArray] = json

        const emitJsonAll: any = {}
        emitJsonAll['json'] = this.firstJsonAllFormSetting
        this.behaviourSettingServices.emitChangeJsonBehaviorSetting(emitJsonAll)
        // const emitJsonAll: any = {};
        // emitJsonAll['is_save'] = true;
        // this.behaviourSettingServices.emitChangeResetDataAll(emitJsonAll);
        this.form_behaviour = 'hidden'
        const emitChangeOptionShow: any = {}
        emitChangeOptionShow['statusFormSetting'] = 'hidden'
        this.behaviourSettingServices.emitChangeStatusFormSetting(emitChangeOptionShow)
        this.behaviourSettingServices.emitChangeView(null)
        this.firstArray = []
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/behavior/modal-behavior-form-setting/modal-behavior-form-setting.component.ts